import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "breadcrumb-item active" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "card-title col-sm-9" }
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-group col-sm-5" }
const _hoisted_17 = { for: "name" }
const _hoisted_18 = { class: "form-group col-sm-5" }
const _hoisted_19 = { for: "description" }
const _hoisted_20 = { class: "form-group col-sm-2" }
const _hoisted_21 = { for: "enabled" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = { class: "card-tools" }
const _hoisted_24 = { class: "card-tools" }
const _hoisted_25 = ["title"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-excel" }, null, -1)
const _hoisted_29 = { class: "card-body table-body" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")
  const _component_download_excel = _resolveComponent("download-excel")
  const _component_table_lite = _resolveComponent("table-lite")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.reports")) + " / " + _toDisplayString(_ctx.$t("labels.page.product")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.reports")), 1),
              _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.$t("labels.page.product")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h3", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("labels.entity.name")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filterReports.name) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterReports.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("labels.entity.description")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "description",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.filterReports.description) = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.filterReports.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("labels.entity.active")), 1),
                  _hoisted_22,
                  _createVNode(_component_Toggle, {
                    modelValue: _ctx.filterReports.enabled,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.filterReports.enabled) = $event)),
                    "on-label": _ctx.$t('labels.yes'),
                    "off-label": _ctx.$t('labels.no')
                  }, null, 8, ["modelValue", "on-label", "off-label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-info",
                  onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                }, _toDisplayString(_ctx.$t('labels.search')), 1),
                _createTextVNode("   "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-default",
                  onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.clear && _ctx.clear(...args)))
                }, _toDisplayString(_ctx.$t('labels.buttons.clean')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                title: _ctx.$t('labels.buttons.reload')
              }, _hoisted_27, 8, _hoisted_25),
              _createTextVNode("   "),
              _createVNode(_component_download_excel, {
                fields: _ctx.listaExcelFields,
                fetch: _ctx.gerarExcel,
                type: "xls",
                worksheet: "product",
                name: "tlpv-report-product.xls",
                class: "btn btn-sm btn-primary btn-novo",
                style: {"width":"33px"},
                "data-tooltip": "Exportar Excel"
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              }, 8, ["fields", "fetch"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[6] || (_cache[6] = $event => (_ctx.table.isLoading = false))
            }, {
              "category.description": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.category ? props.value.category.description : '-'), 1)
              ]),
              "product_type.description": _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.product_type ? props.value.product_type.description : '-'), 1)
              ]),
              price: _withCtx((props) => [
                _createTextVNode(_toDisplayString(_ctx.formatNumber(props.value.price)), 1)
              ]),
              discount: _withCtx((props) => [
                _createTextVNode(_toDisplayString(_ctx.formatNumber(props.value.discount)), 1)
              ]),
              video_display_name: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.value.video_display_name ? props.value.video_display_name : '-'), 1)
              ]),
              is_highlight: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.is_highlight,
              'bg-danger': !props.value.is_highlight
            }])
                }, _toDisplayString(props.value.is_highlight ? _ctx.$t('labels.yes') : _ctx.$t('labels.no')), 3)
              ]),
              enabled: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
              'bg-success': props.value.enabled,
              'bg-danger': !props.value.enabled
            }])
                }, _toDisplayString(props.value.enabled ? _ctx.$t('labels.active') : _ctx.$t('labels.inactive')), 3)
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}